import React from 'react';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import {
    flexCenterAll,
    truncatedText
} from '@honeybook/hbui/dist/styles/mixins';
import {
    ActionTypeText,
    AutomationBlockContent
} from '../AutomationsBuilder.styles';
import { TAutomationBlockAction } from '~/types/automation.types';
import MoveTo24 from '@honeybook/icons/dist/icons/MoveTo24';

const AutomationBlockActionPipelineStage: TAutomationBlockAction = ({
    step,
    color
}) => {
    return (
        <AutomationBlockContent>
            <MoveTo24 color={color} />
            <ActionTypeText type="Title3DarkPrimary">
                Move Pipeline stage
            </ActionTypeText>
            <Template>
                <Title
                    align="center"
                    type={
                        step.stage ? 'Body6DarkPrimary' : 'Body6DarkSecondary'
                    }
                >
                    {step.title}
                </Title>
            </Template>
        </AutomationBlockContent>
    );
};

export default observer(AutomationBlockActionPipelineStage);

const Template = styled.div`
    align-self: stretch;
    ${flexCenterAll}
`;

const Title = styled(HBText)`
    ${truncatedText}
`;
